<template>
  <div class="questionnaire">
    <div class="header">
      <img src="@/assets/img/logo_q.png" alt="" />
    </div>
    <div class="title">
      <p>顾客满意度调查</p>
      <p>“温暖顾客心，倾听顾客言，加强责任心，安全又放心”</p>
    </div>
    <div class="division">
      <div class="division_title">就诊科别：</div>
      <van-radio-group v-model="division" direction="horizontal">
        <van-radio
          v-for="(item, index) in division_list"
          :key="index"
          :name="item"
          shape="square"
          checked-color="#ff410a"
          >{{ item }}</van-radio
        >
      </van-radio-group>
    </div>
    <div class="project">
      <div class="project_title">就诊项目：</div>
      <van-field
        v-model="project"
        :border="false"
        placeholder="请输入您的就诊项目"
      />
      <van-divider />
    </div>
    <div class="content">
      <div class="content_title">满意度调查表（ 直接在选项处打√ ）</div>
      <div class="ul">
        <div class="li" v-for="(item, index) in list" :key="index">
          <div class="li_title">{{ index + 1 + "，" + item.title }}</div>
          <div class="li_content">
            <van-radio-group v-model="item.answer" direction="horizontal">
              <van-radio
                v-for="(value, idx) in item.topic"
                :key="idx"
                :name="value"
                shape="square"
                checked-color="#ff410a"
                >{{ value }}</van-radio
              >
            </van-radio-group>
            <van-field
              v-if="item.answer == '主要问题'"
              :border="false"
              v-model="item.tip"
              placeholder="请输入主要问题"
            />
            <van-divider v-if="item.answer == '主要问题'" />
          </div>
        </div>
      </div>
    </div>
    <div class="opinion">
      <div class="opinion_title">您的宝贵意见：</div>
      <div class="opinion_box van-hairline--surround">
        <van-field
          type="textarea"
          v-model="opinion"
          autosize
          placeholder="请输入您宝贵的意见"
        />
      </div>
    </div>
    <div class="signature">
      <div class="signature_title">签名：</div>
      <div class="signature_box">
        <vue-esign ref="esign" bgColor="#eeeeee" :isClearBgColor="false" />
      </div>
      <div class="signature_btn">
        <van-button type="primary" size="small" @click="reset"
          >清空签名</van-button
        >
      </div>
      <van-button color="#ff410a" block @click="submit">提交</van-button>
    </div>
  </div>
</template>
<script>
import { RadioGroup, Radio, Field, Divider, Button, Toast } from "vant";
import vueEsign from "vue-esign";
import { getUser } from "@api/user";
import { getUploadImageNew, getWechatConfig } from "../../api/public";
import { postCustomerSatisfaction } from "../../api/lcapi";
import wx from "weixin-js-sdk";
export default {
  name: "questionnaire",
  components: {
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Field.name]: Field,
    [Divider.name]: Divider,
    [Button.name]: Button,
    vueEsign,
  },
  data() {
    return {
      info: "",
      uid: "",
      division_list: ["整形科", "皮肤科", "微整科", "口腔科"],
      division: "",
      project: "",
      list: [
        {
          title: "一楼前台人员的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "二楼前台人员的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "三楼前台人员的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "咨询老师的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "摄影师服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "收费室服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "医生的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "护士的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "客服人员的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "检验科的服务态度如何？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
        {
          title: "治疗时是否满意？",
          topic: ["很好", " 一般", "冷冰冰", "主要问题"],
          answer: "",
          tip: "",
        },
      ],
      opinion: "",
    };
  },
  mounted() {
    const that = this;
    if (this.$route.query.id) {
      this.uid = this.$route.query.id;
    } else {
      this.uid = 0;
    }
    console.log(this.uid);
    getUser().then((res) => {
      this.info = res.data;
    });
    getWechatConfig().then((data) => {
      wx.config({
        debug: false,
        appId: data.data.appId,
        timestamp: data.data.timestamp,
        timestamp: data.data.timestamp,
        nonceStr: data.data.nonceStr,
        signature: data.data.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "translateVoice",
          "startRecord",
          "stopRecord",
          "onRecordEnd",
          "playVoice",
          "pauseVoice",
          "stopVoice",
          "uploadVoice",
          "downloadVoice",
          "chooseImage",
          "previewImage",
          "uploadImage",
          "downloadImage",
          "getNetworkType",
          "openLocation",
          "getLocation",
          "hideOptionMenu",
          "showOptionMenu",
          "closeWindow",
          "scanQRCode",
          "chooseWXPay",
          "openProductSpecificView",
          "addCard",
          "chooseCard",
          "openCard",
        ],
        openTagList: ["wx-open-launch-weapp"],
      });
      wx.ready(function() {
        //config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
        wx.updateAppMessageShareData({
          title: "满意度调查表", // 分享标题
          desc: "满意度调查表", // 分享描述
          link:
            "https://jiaojiao.yanjiusuo.xyz/questionnaire?id=" + that.info.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.onMenuShareAppMessage({
          title: "满意度调查表", // 分享标题
          desc: "满意度调查表", // 分享描述
          link:
            "https://jiaojiao.yanjiusuo.xyz/questionnaire?id=" + that.info.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.updateTimelineShareData({
          title: "满意度调查表", // 分享标题
          desc: "满意度调查表", // 分享描述
          link:
            "https://jiaojiao.yanjiusuo.xyz/questionnaire?id=" + that.info.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
        wx.onMenuShareTimeline({
          title: "满意度调查表", // 分享标题
          desc: "满意度调查表", // 分享描述
          link:
            "https://jiaojiao.yanjiusuo.xyz/questionnaire?id=" + that.info.uid, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://jd-medical-beauty.oss-cn-chengdu.aliyuncs.com/product/dc7b420220411105559327.png", // 分享图标
          success: function() {
            // 设置成功
          },
        });
      });
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
  },
  methods: {
    /**
     * Base64转码
     */
    base64ImgtoFile(dataurl, filename = "file") {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let suffix = mime.split("/")[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      });
    },
    /**
     * 清空签名
     */
    reset() {
      this.$refs.esign.reset();
    },
    /**
     * 提交信息
     */
    submit() {
      const that = this;
      // if (!this.division) return Toast("请选择就诊科别");
      // if (!this.project) return Toast("请输入就诊项目");
      // for (let i = 0; i < this.list.length; i++) {
      //   let num = i + 1;
      //   if (this.list[i].answer == "") return Toast("请填写第" + num + "题");
      //   if (this.list[i].answer == "主要问题" && this.list[i].tip == "")
      //     return Toast("请描述第" + num + "题的主要问题");
      // }
      this.$refs.esign
        .generate()
        .then((res) => {
          console.log(this.base64ImgtoFile(res));
          var param = new FormData();
          let files = this.base64ImgtoFile(res);
          param.append("file", files, files.name);
          Toast.loading({
            message: "提交中...",
            overlay: true,
            duration: 0,
          });
          getUploadImageNew(param)
            .then((res1) => {
              let lists = [];
              lists.push({
                name: "就诊科别",
                answer: that.division,
              });
              lists.push({
                name: "治疗项目",
                answer: that.project,
              });
              let satisficingL = [];
              that.list.forEach((item) => {
                let data = {
                  name: item.title,
                };
                if (item.answer == "主要问题") {
                  data.answer = item.tip;
                } else {
                  data.answer = item.answer;
                }
                satisficingL.push(data);
              });
              lists.push({
                satisficing: satisficingL,
              });
              lists.push({
                name: "您的宝贵意见",
                answer: that.opinion,
              });
              lists.push({
                name: "求美者签名",
                answer: res1.data.url,
              });
              postCustomerSatisfaction({
                content: JSON.stringify(lists),
                puid: that.uid,
              })
                .then((res2) => {
                  Toast(res2.msg);
                  that.$router.go(-1);
                })
                .catch((err) => {
                  Toast(err);
                });
            })
            .catch((err) => {
              Toast("签名上传失败，请重试");
            });
        })
        .catch((err) => {
          Toast("请输入签名");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  justify-content: center;
}
.title {
  margin: 0.32rem;
}
.title p:first-child {
  font-weight: bold;
  font-size: 0.48rem;
}
.title p:last-child {
  margin-top: 0.1rem;
  font-size: 0.24rem;
}
.division {
  margin: 0.32rem;
}
.division_title {
  margin-bottom: 0.32rem;
  font-weight: bold;
}
.content,
.opinion,
.project,
.signature {
  margin: 0.44rem 0.32rem;
}
.content_title,
.opinion_title,
.project_title,
.signature_title {
  font-weight: bold;
}

.li {
  margin: 0.44rem 0;
}
.li_content {
  margin-top: 0.1rem;
}

.van-cell {
  font-size: 0.32rem !important;
  padding: 10px 16px 2px 16px !important;
}
.van-divider {
  margin: 0 !important;
}
.van-radio-group--horizontal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.opinion_box,
.signature_box {
  margin-top: 0.32rem;
}
.signature_btn {
  margin: 0.32rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
